module.exports = __webpack_public_path__ + "static/media/Cooperationbg@3x.e7fba656.png";